import { metricConfig, TIME_PERIOD_OPTIONS } from '../data/metrics/metricConfigBuilder';
import { getCurrencySymbol } from './formatterUtil';

export const generateTPColumnHeaders = (metrics, inputData, benchMarkName) => {
    const headers = ['Account Breakdown'];
    const benchmarks = [];
    const attribution = [];
    const headersWithCode = [{ id: 'Account Breakdown', header: 'Account Breakdown', tp: '' }];
    metrics.xdeMetricsOrder.map(metric => {
        const metricId = metric.colId.split('|');
        const metricObj = metricConfig[metricId[0]];
        if (metricObj.applicableGroup.indexOf('Account') !== -1) {
            let metricName = '';
            metricName += getMetricName(metricObj);
            if (metricObj.isTimePeriodMetric) {
                metricName += getTimePeriods(metricObj, metricId[1]);
            }
            metricName += '(P)';
            headers.push(metricName);
            headersWithCode.push({ id: metricId[0], header: metricName, tp: metricId[1] ? metricId[1] : '' });
        }
        if (metricObj.applicableGroup.indexOf('Benchmark') !== -1
            && inputData?.benchmark?.benchmarkUsage !== "None") {
            let benchmarkName = '';
            benchmarkName += getMetricName(metricObj) + benchMarkName;
            if (metricObj.isTimePeriodMetric) {
                benchmarkName += getTimePeriods(metricObj, metricId[1]);
            }
            benchmarkName += '(B)';
            benchmarks.push(benchmarkName);
            headersWithCode.push({ id: metricId[0], header: benchmarkName, tp: metricId[1] ? metricId[1] : '', isBenchmark: true });
        }
        if (metricObj.applicableGroup.indexOf('Attribution') !== -1
            && inputData?.workspaceType?.key === "attribution") {
            let attributionName = '';
            attributionName += getMetricName(metricObj);
            if (metricObj.isTimePeriodMetric) {
                attributionName += getTimePeriods(metricObj, metricId[1]);
            }
            attributionName += '(A)';
            attribution.push(attributionName);
            headersWithCode.push({ id: metricId[0], header: attributionName, tp: metricId[1] ? metricId[1] : '', isAttribution: true });
        }
    });

    return { headers: [[...headers, ...benchmarks, ...attribution]], headersWithCode };
}

const getGroupMetricName = (metricObj) => {
    if (!metricObj.isTimePeriodMetric) {
        return metricObj.displayName;
    }
    return getMetricName(metricObj);
}

const getMetricName = (metricObj) => {
    let metricName = '';
    if (metricObj.appendToHeader && metricObj.appendToHeader !== '') {
        metricName = metricObj.appendToHeader + ' ';
    }
    metricName += metricObj.displayName;
    return metricName;
}

const getTimePeriods = (metricObj, tp) => {
    let timePeriod = '';
    if (tp && tp !== '') {
        return '-' + TIME_PERIOD_OPTIONS[tp].displayName;
    }
    return timePeriod;
}

export const getBenchMarkName = (response) => {
    let benchMarkName = '';
    let results = [];
    if (response?.rows?.length > 0) {
        response.rows.map(row =>
            row.datasets.map(ds =>
                ds.name === 'targetBenchmark' ?
                    (results = [...results, ...ds.periodResults]) : null
            )
        )
    }
    results = [...new Set([...results
        .map(obj => obj.metric === 'ObjectName' ? obj.value : null)
        .filter(res => res !== null)])];
    if (results.length > 0) {
        benchMarkName = '(' + results[0] + ')';
    }
    return benchMarkName;
}

export const generateTSColumnHeaders = (response, inputData, accountsMap) => {
    let results = [];
    let headers = { 'label': getGroupName(inputData) };
    let children = [{ label: "End Date" }];
    let headerMap = ["End Date"];
    if (inputData?.benchmark && inputData?.benchmark?.benchmarkUsage !== "None") {
        children.push({
            "label": "Totals",
            "children": [
                { label: "Account" },
                { label: "Benchmark" },
            ],
        });
        headerMap.push("Totals|Account");
        headerMap.push("Totals|Benchmark");
    } else {
        children.push({
            "label": "Totals",
            "children": [
                { label: "Account" }
            ],
        });
        headerMap.push("Totals|Account");
    }
    response.rows.forEach(row => {
        let isAccount = false;
        let isBenchmark = false;
        if (row.cubeDimensionValues.length > 0) {
            if (row.datasets.filter(ds => ds.name === 'sourcePortfolio').length > 0) {
                isAccount = true;
            }
            if (inputData?.benchmark && inputData?.benchmark?.benchmarkUsage !== "None" &&
                row.datasets.filter(ds => ds.name === 'targetBenchmark').length > 0) {
                isBenchmark = true;
            }
            let { response, mapping } = getHeaders(row.cubeDimensionValues, isAccount, isBenchmark, headerMap, accountsMap);
            if (response) {
                children.push(response);
                headerMap = [...headerMap, ...mapping];
            }
        }
    });
    headers['children'] = children;
    results.push(headers);
    console.log({ columns: results, mappings: headerMap });
    return { columns: results, mappings: headerMap };
}

const getGroupName = (inputData) => {
    let grpName = '';
    if (!inputData.analysisLevel || inputData.analysisLevel.key !== 'Hierarchy') {
        if (inputData.accountId && inputData.accountId.length === 1) {
            grpName = inputData.accountId[0].accountID + '-' + inputData.accountId[0].accountLongName;
        } else {
            grpName = 'Custom Group';
        }
    } else {
        grpName = inputData.hierarchy.level1GroupName;
    }
    return grpName;
}

const getCurrency = (metricObj, inputData) => {
        if (!metricObj.showCurrency) {
            return metricObj.symbol;
        }
        if (inputData.analysisLevel?.key === 'Hierarchy') {
            return getCurrencySymbol('All', true);
        }
        if (inputData.accountId && inputData.accountId.length > 0) {
            return getCurrencySymbol(inputData.accountId[0].currencyCodeISO3, true);
        }
}

export const generateTimePeriodColumnHeaders = (response, metrics, inputData, accountsMap, benchMarkName) => {
    let results = [{ 'label': 'Account Breakdown' }];
    const colheaders = ['Account Breakdown'];
    const benchmarks = [];
    const attribution = [];
    const headersWithCode = [{ id: 'Account Breakdown', header: 'Account Breakdown', tp: '' }];
    metrics.xdeMetricsOrder.map(metric => {
        const metricId = metric.colId.split('|');
        const metricObj = metricConfig[metricId[0]];

        const currency = getCurrency(metricObj, inputData);
        if(metricObj.applicableGroup.indexOf('Account') !== -1){
            let colMetricName = getMetricName(metricObj);

            const res = results.filter(res => res.label === 'Account')
            let headers = res.length > 0 ? res[0] : { label: "Account", children: null };
            let metricName = '';
            metricName = getGroupMetricName(metricObj) + `` + (currency ? ` ${currency}` : '');
            let metricChild = headers?.children?.filter(child => child.label === metricName);
            metricChild = metricChild?.length > 0 ? metricChild[0] : { label: metricName, children: null };
            if (metricObj.isTimePeriodMetric) {
                let tp = TIME_PERIOD_OPTIONS[metricId[1]].displayName;
                if (metricChild['children'] === null) {
                    metricChild['children'] = [];
                }
                metricChild['children'].push({ label: tp });

                colMetricName += getTimePeriods(metricObj, metricId[1]);
            } else if (metricObj.appendToHeader && metricObj.appendToHeader !== '') {
                metricChild.children = [];
                metricChild.children.push({ label: metricObj.appendToHeader });
            }
            if (headers['children'] === null || headers['children'].filter(m => m.label === metricName).length === 0) {
                if (headers['children'] === null) {
                    headers['children'] = [];
                }
                headers['children'].push(metricChild);
            }
            if (results.filter(r => r.label === 'Account').length === 0) {
                results.push(headers);
            }

            colMetricName += '(P)';
            colheaders.push(colMetricName);
            const headerIndex = headersWithCode.findLastIndex(h => h.id === metricId[0]);
            if (headerIndex === -1) {
                headersWithCode.push({ id: metricId[0], header: colMetricName, tp: metricId[1] ? metricId[1] : '' });
            } else {
                headersWithCode.splice(headerIndex + 1, 0, { id: metricId[0], header: colMetricName, tp: metricId[1] ? metricId[1] : '' });
            }
        }
        if(metricObj.applicableGroup.indexOf('Benchmark') !== -1 
            && inputData?.benchmark?.benchmarkUsage !== "None"){
                let colbenchmarkName = getMetricName(metricObj)+benchMarkName;
                
                const bName = 'Benchmark'+benchMarkName;
                const benchmarkRes = results.filter(res => res.label === bName)
                let bHeaders = benchmarkRes.length > 0 ? benchmarkRes[0] : { label: bName, children: null };
                let benchmarkName = '';
                benchmarkName = getGroupMetricName(metricObj) + `` + (currency ? ` ${currency}` : '');
                let bChild = bHeaders?.children?.filter(child => child.label === benchmarkName);
                bChild = bChild?.length > 0 ? bChild[0] : { label: benchmarkName, children: null };
                if(metricObj.isTimePeriodMetric){
                    let tp = TIME_PERIOD_OPTIONS[metricId[1]].displayName;
                    if(bChild['children'] === null){
                        bChild['children'] = [];
                    }
                    bChild['children'].push({label: tp});

                colbenchmarkName += getTimePeriods(metricObj, metricId[1]);
            } else if (metricObj.appendToHeader && metricObj.appendToHeader !== '') {
                bChild.children = [];
                bChild.children.push({ label: metricObj.appendToHeader });
            }
            if (bHeaders['children'] === null || bHeaders['children'].filter(m => m.label === benchmarkName).length === 0) {
                if (bHeaders['children'] === null) {
                    bHeaders['children'] = [];
                }
                bHeaders['children'].push(bChild);
            }
            if (results.filter(r => r.label === bName).length === 0) {
                results.push(bHeaders);
            }

            colbenchmarkName += '(B)';
            benchmarks.push(colbenchmarkName);
            const headerBIndex = headersWithCode.findLastIndex(h => h.id === metricId[0]);
            if (headerBIndex === -1) {
                headersWithCode.push({ id: metricId[0], header: colbenchmarkName, tp: metricId[1] ? metricId[1] : '', isBenchmark: true });
            } else {
                headersWithCode.splice(headerBIndex + 1, 0, { id: metricId[0], header: colbenchmarkName, tp: metricId[1] ? metricId[1] : '', isBenchmark: true });
            }
        }
        if(metricObj.applicableGroup.indexOf('Attribution') !== -1 
            && inputData?.workspaceType?.key === "attribution"){
                let colattributionName = getMetricName(metricObj);
                
                const attribRes = results.filter(res => res.label === 'Attribution')
                let attribHeaders = attribRes.length > 0 ? attribRes[0] : { label: "Attribution", children: null };
                let attributionName = '';
                attributionName = getGroupMetricName(metricObj) + `` + (currency ? ` ${currency}` : '');
                let attribChild = attribHeaders?.children?.filter(child => child.label === attributionName);
                attribChild = attribChild?.length > 0 ? attribChild[0] : { label: attributionName, children: null };
                if(metricObj.isTimePeriodMetric){
                    let tp = TIME_PERIOD_OPTIONS[metricId[1]].displayName;
                    if(attribChild['children'] === null){
                        attribChild['children'] = [];
                    }
                    attribChild['children'].push({label: tp});

                colattributionName += getTimePeriods(metricObj, metricId[1]);
            } else if (metricObj.appendToHeader && metricObj.appendToHeader !== '') {
                attribChild.children = [];
                attribChild.children.push({ label: metricObj.appendToHeader });
            }
            if (attribHeaders['children'] === null || attribHeaders['children'].filter(m => m.label === attributionName).length === 0) {
                if (attribHeaders['children'] === null) {
                    attribHeaders['children'] = [];
                }
                attribHeaders['children'].push(attribChild);
            }
            if (results.filter(r => r.label === 'Attribution').length === 0) {
                results.push(attribHeaders);
            }

            colattributionName += '(A)';
            attribution.push(colattributionName);
            const headerAIndex = headersWithCode.findLastIndex(h => h.id === metricId[0]);
            if (headerAIndex === -1) {
                headersWithCode.push({ id: metricId[0], header: colattributionName, tp: metricId[1] ? metricId[1] : '', isAttribution: true });
            } else {
                headersWithCode.splice(headerAIndex + 1, 0, { id: metricId[0], header: colattributionName, tp: metricId[1] ? metricId[1] : '', isAttribution: true });
            }
        }
    });

    return { tpColumns: results, tpMappings: headersWithCode, headers: [...colheaders, ...benchmarks, ...attribution] };
}

const getHeaders = (dims, isAccount, isBenchmark, children, accountsMap) => {
    let res = '';
    let combinedHeaders = [];
    let headersAccount = '';
    let headersBenchmark = '';
    for (let i = dims.length - 1; i >= 0; i--) {
        const accObj = accountsMap[dims[i].value];
        const value = dims[i].column === 'AccountBusinessID' ? `${accObj.accountID} - ${accObj.accountLongName}` : dims[i].value;
        if (i === dims.length - 1) {
            res = '{"label":"' + value + '","children":[';
            headersAccount = value;
            if (isAccount) {
                res += '{"label":"Account" }';
                headersAccount += '|Account';
            }
            if (isBenchmark) {
                if (isAccount) {
                    res += ',';
                }
                res += '{"label":"Benchmark" }';
                headersBenchmark = headersAccount.replace('Account', 'Benchmark');
            }
            res += ']}';
        } else {
            res = '{"label":"' + value + '","children":[' + res + ']}';
            headersAccount = value + '|' + headersAccount;
            headersBenchmark = headersBenchmark != '' ? (value + '|' + headersBenchmark) : '';
        }
    }
    res = JSON.parse(res);
    // if(children.some(item => deepCompare(item, res))){
    //     return {response : null, mapping : null};
    // }
    if (children.indexOf(headersAccount) === -1 && children.indexOf(headersBenchmark) === -1) {
        combinedHeaders.push(headersAccount);
        if (headersBenchmark !== '') {
            combinedHeaders.push(headersBenchmark);
        }
        return { response: res, mapping: combinedHeaders };
    } else {
        return { response: null, mapping: null };
    }
}

function deepCompare(obj1, obj2) {
    if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) {
        return obj1 === obj2;
    }
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (let key of keys1) {
        if (!keys2.includes(key) || !deepCompare(obj1[key], obj2[key])) {
            return false;
        }
    }
    return true;
}